import { ca } from "date-fns/locale";

export const getStrByApproveType = (approveStatus) => {
    let re = '';
    if (approveStatus == 0) {
        re = "待提交";
    } else if (approveStatus == 1) {
        re = "待审核";
    } else if (approveStatus == 2) {
        re = "通过";
    } else if (approveStatus == 3) {
        re = "驳回";
    } else if (approveStatus == 4) {
        re = "废弃";
    }
    return re;
}

export const getStrByActionType = type => {
    let ret = '';
    switch (type) {
        case 0:
            ret = '新增';
            break;
        case 1:
            ret = '编缉';
            break;
        case 2:
            ret = '删除';
            break;
        case 3:
            ret = '启用';
            break;
        case 4:
            ret = '禁用';
            break;
    }
    return ret;
}

export const ACTIONTYPE = () => {
    return {
        ADD: 0,
        EDIT: 1,
        DEL: 2,
        ENABLE: 3,
        DISABLE: 4
    }
}